var render = function render(){var _vm=this,_c=_vm._self._c;return _c('QuestionYesNo',{attrs:{"title":"Gender","question":{ options: _vm.options, designator: 'gender' },"initValue":_vm.initValue},on:{"input":_vm.handleChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }